// region_payout is scoped to MATH. class_ratio is an integer in the API
// (1 == 1:1), not the "1:1" label. The ratio is selectable in the UI; 1 is the default.
export const COURSE = 'MATH';

// Course tabs are derived from the fetched rows; this only fixes display order,
// with any unknown course appended after these in alphabetical order.
export const COURSE_ORDER = ['MATH', 'SCIENCE', 'CODING'];
export const DEFAULT_CLASS_RATIO = 1;
export const DEFAULT_CURRENCY = 'INR';

// Top-level toggle: browse existing rates (read-only) or bulk-create one window
// per cell of the grid.
export const VIEW_MODE = {
  GRID: 'grid',
  BULK: 'bulk',
};

// Fetch filter over validity windows. "active" (default) = windows containing today.
export const VALIDITY_MODE = {
  ACTIVE: 'active',
  ALL: 'all',
  AS_OF: 'as_of',
};

export const VALIDITY_MODE_OPTIONS = [
  { value: VALIDITY_MODE.ACTIVE, label: 'Active today' },
  { value: VALIDITY_MODE.ALL, label: 'All windows' },
  { value: VALIDITY_MODE.AS_OF, label: 'As of date…' },
];

export const ratioLabel = ratio => `1:${ratio}`;

// Delivery channel is derived from the region name (region_payout has no channel
// column): CUEMATH_CENTER_* are physical centers = offline; *HYBRID* regions
// (IN_HYBRID_*, LEGACY_HYBRID) are hybrid; every other region is online. Used to
// filter which region tabs show.
export const OFFLINE_REGION_PREFIX = 'CUEMATH_CENTER';
export const HYBRID_REGION_TOKEN = 'HYBRID';
// Bare hybrid region keys that don't carry the HYBRID token in their name.
export const HYBRID_REGIONS = ['IN', 'IS'];

export const CHANNEL = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  HYBRID: 'hybrid',
};

export const CHANNEL_OPTIONS = [
  { value: CHANNEL.ONLINE, label: 'Online' },
  { value: CHANNEL.OFFLINE, label: 'Offline (centers)' },
  { value: CHANNEL.HYBRID, label: 'Hybrid' },
];

export const regionChannel = region => {
  if (!region) return CHANNEL.ONLINE;
  if (region.startsWith(OFFLINE_REGION_PREFIX)) return CHANNEL.OFFLINE;
  if (region.includes(HYBRID_REGION_TOKEN) || HYBRID_REGIONS.includes(region))
    return CHANNEL.HYBRID;
  return CHANNEL.ONLINE;
};

// Rows of the grid.
export const GRADE_RANGES = ['K-2', '3-5', '6-8', '9-12'];

// Columns of the grid. enrollment_type tiers (display order).
export const TIERS = ['BASIC', 'PLUS', 'HIGH'];
